import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNeutralBlueEmoticon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_5302_90593)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M24 48C37.2546 48 48 37.2546 48 24C48 10.7454 37.2546 0 24 0C10.7454 0 0 10.7454 0 24C0 37.2546 10.7454 48 24 48Z",
				fill: "#1DBADF"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.2669 19.8895C14.2669 22.5275 12.1288 24.6686 9.48773 24.6686C6.84663 24.6686 4.70859 22.5306 4.70859 19.8895C4.70859 17.2484 6.84969 15.1104 9.48773 15.1104C12.1258 15.1104 14.2669 17.2515 14.2669 19.8895Z",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.34969 18.0402C9.34969 18.8162 8.72086 19.4451 7.94479 19.4451C7.16871 19.4451 6.53988 18.8162 6.53988 18.0402C6.53988 17.2641 7.16871 16.6353 7.94479 16.6353C8.72086 16.6353 9.34969 17.2641 9.34969 18.0402Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.8896 20.2546C10.8896 20.7025 10.5276 21.0645 10.0798 21.0645C9.6319 21.0645 9.26994 20.7025 9.26994 20.2546C9.26994 19.8068 9.6319 19.4448 10.0798 19.4448C10.5276 19.4448 10.8896 19.8068 10.8896 20.2546Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M43.2883 19.8895C43.2883 22.5275 41.1472 24.6686 38.5092 24.6686C35.8712 24.6686 33.7301 22.5306 33.7301 19.8895C33.7301 17.2484 35.8712 15.1104 38.5092 15.1104C41.1472 15.1104 43.2883 17.2515 43.2883 19.8895Z",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M38.3681 18.0402C38.3681 18.8162 37.7393 19.4451 36.9632 19.4451C36.1871 19.4451 35.5583 18.8162 35.5583 18.0402C35.5583 17.2641 36.1871 16.6353 36.9632 16.6353C37.7393 16.6353 38.3681 17.2641 38.3681 18.0402Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M39.908 20.2546C39.908 20.7025 39.546 21.0645 39.0982 21.0645C38.6503 21.0645 38.2883 20.7025 38.2883 20.2546C38.2883 19.8068 38.6503 19.4448 39.0982 19.4448C39.546 19.4448 39.908 19.8068 39.908 20.2546Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M29.6196 27.2885C28.8313 29.6842 26.5951 31.3314 24.0798 31.3958C21.5706 31.4603 19.227 29.8406 18.3712 27.4879C18.2331 27.1075 17.8712 26.8529 17.454 26.9664C17.0859 27.0676 16.7945 27.5001 16.9325 27.8836C18.0276 30.8928 20.862 32.9142 24.0767 32.8866C27.2669 32.859 30.0705 30.6811 31.0552 27.6842C31.3558 26.767 29.9172 26.3774 29.6166 27.2885",
				fill: "#1C1C1C"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.9202 28.7426C12.9202 30.0861 11.4571 31.1751 9.65031 31.1751C7.84356 31.1751 6.3773 30.0861 6.3773 28.7426C6.3773 27.399 7.84356 26.3101 9.65031 26.3101C11.4571 26.3101 12.9202 27.399 12.9202 28.7426Z",
				fill: "#FF2180"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.6196 28.7426C41.6196 30.0861 40.1564 31.1751 38.3497 31.1751C36.5429 31.1751 35.0767 30.0861 35.0767 28.7426C35.0767 27.399 36.5429 26.3101 38.3497 26.3101C40.1564 26.3101 41.6196 27.399 41.6196 28.7426Z",
				fill: "#FF2180"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_5302_90593",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 48,
			height: 48,
			fill: "white"
		})
	}) })]
});
export default SvgNeutralBlueEmoticon;
